import React, { useState, useRef, useCallback } from 'react';
import './style.scss';
import clsx from 'clsx';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js'; //https://github.com/dozoisch/react-google-recaptcha
import GlobalSearchComponent from '../Shared/components/SearchComponent';
import { withTranslation } from 'react-i18next';
import { SearchContext } from '../Shared/components/SearchComponent/context/SearchContext';
import { helpers } from '../Shared/components/SearchComponent/helpers';
import SearchTitle from '../Shared/components/SearchComponent/SearchTitle';
import PopularSearch from '../Shared/components/SearchComponent/PopularSearch';
import { useLazyQuery } from 'react-apollo';
import { loader as gqlLoader } from 'graphql.macro';
import { debounce } from '@mui/material';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

const query = gqlLoader(
  '../Shared/components/SearchComponent/API/GlobalSearchSuggestionsQuery.graphql'
);

const Search = (props) => {
  //number of characters to enter before triggering the search
  const context = useSitecoreContext();
  const [searchTerm, setSearchTerm] = useState('');
  const inputSearchRef = useRef(null);
  const {
    pageSize,
    enablePopularSearches,
    inputLabel,
    placeholder,
    popularSearchTitle,
    popularSearches,
    resultPage,
    title,
  } = props?.fields;
  const { t, params, i18n } = props;

  let language = i18n.language;
  let pagination = {
    currentPage: 1,
    itemsPerPage: pageSize?.value + 1,
  };

  const startSearchCharatersLength = 5;
  const hasPagination = false;
  let templateName = '';
  const fromPopup = true;
  let indexName = 'FAB2_#datebase#_index'.replace(
    '#datebase#',
    context?.sitecoreContext?.route?.databaseName
  );

  const [isOpen, setIsOpen] = useState(false);
  const [isCategoryDropdownOpen, setIsCategoryDropdownOpen] = useState(false);
  const [wordsNotFoundError, setWordsNotFoundError] = useState(false);
  const [dataRetrievedItems, setDataRetrievedItems] = useState([]);
  const [focusedIndex, setFocusedIndex] = useState(-1);

  const [totalSearchResultsCount, setTotalSearchResultsCount] = useState(0);
  let summaryText = 'resultsSummary';

const [getSearchSuggestionsData, {}] = useLazyQuery(
  query,
  {
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      if (searchTerm === '') {
        return null;
      }
      setWordsNotFoundError(false);
      setIsOpen(false);

      let items = data?.search?.results?.items;

      // Apply your filter to hide items with hidePage = "1" or "true"
      if (items && items.length > 0) {
        items = items.filter(item => {
          const hideFromSearch = item?.item?.hidePage?.value;
          return hideFromSearch !== "1" && hideFromSearch !== "true";
        });
        //console.log('Filtered search items', items);
      }

      if (items?.length <= 0) {
        setWordsNotFoundError(true);
        setTotalSearchResultsCount(0);
      } else if (items?.length > 0) {
        setTotalSearchResultsCount(items.length);
        setDataRetrievedItems(items);
        summaryText = items?.length > 0 ? 'resultsSummary' : 'resultSummary';
        setIsOpen(items?.length > 0);
        inputSearchRef.current.focus();
      }
    },
  },
  [searchTerm]
);

  const getSearchSuggestions = useCallback(debounce(getSearchSuggestionsData, 500), []);

  const providerValue = {
    t,
    popularSearches,
    pagination,
    language,
    indexName,
    templateName,
    title,
    popularSearchTitle,
    popularSearches,
    pageSize,
    enablePopularSearches,
    inputLabel,
    placeholder,
    resultPage,
    searchTerm,
    setSearchTerm,
    startSearchCharatersLength,
    helpers,
    isOpen,
    setIsOpen,
    wordsNotFoundError,
    setWordsNotFoundError,
    dataRetrievedItems,
    setDataRetrievedItems,
    focusedIndex,
    setFocusedIndex,
    getSearchSuggestions,
    hasPagination,
    summaryText,
    fromPopup,
    inputSearchRef,
    totalSearchResultsCount,
    isCategoryDropdownOpen,
    setIsCategoryDropdownOpen,
  };
  if (!props?.fields || !props.params) {
    return <GenericPlaceholder componentName="Search" />;
  }
  return (
    <div id="search-popup-id" className={clsx('search-popup', 'add-margins', params?.Styles)}>
      <div className="popup-search-layer"></div>
      <div
        id="popup-search-content-id"
        className="popup-search-content flex-it flex-align-item-center flex-justify-center"
      >
        <div className="content">
          <div className="popup-search-wrap">
            <SearchContext.Provider value={providerValue}>
              <SearchTitle />
              <GlobalSearchComponent />
              <PopularSearch />
            </SearchContext.Provider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(Search);
